// extracted by mini-css-extract-plugin
export default {"melodyVideo":"MO-z","isFullWidth":"NO-z","landingPageVideo":"OO-z","play":"PO-z","iframeVideo":"QO-z","playHidden":"RO-z","fullwidth":"SO-z"};